import { translate } from "app/filters/i18nFilter";
import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import { COMPANY_ANALYSIS_SIGNALS } from "app/pages/sales-intelligence/constants/routes";
import SignalsCardEmpty from "app/pages/sales-intelligence/pages/company-analysis/components/cards/signals-card/SignalsCardEmpty/SignalsCardEmpty";
import Card from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/Card";
import CardFooter from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardFooter/CardFooter";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";

import SignalsCardTracked from "./SignalsCardTracked";

const SignalsCardWithErrorBoundary = () => (
    <ErrorBoundaryWithLogging
        fallback={
            <Card
                dataAutomation="signals-card"
                renderContent={() => <SignalsCardEmpty />}
                header={<CardHeader title={translate("si.company-analysis.signals.card.header")} />}
                footer={
                    <CardFooter
                        stateId={COMPANY_ANALYSIS_SIGNALS}
                        linkText="si.company-analysis.signals.card.full_report"
                    />
                }
                width="50%"
            />
        }
    >
        <SignalsCardTracked />
    </ErrorBoundaryWithLogging>
);

export default SignalsCardWithErrorBoundary;
